module.exports = {
	"name": "Vin Bar",
	"foodRecommendations": [
		{
			"text": "Try the wine, they have a bunch of it.",
			"person": "Ian McKenzie"
		}
	],
	"address": "111 W Liberty St, Ann Arbor, MI 48104",
	"images": [],
	"position": {
		"lat": 42.2794,
		"lng": -83.7492
	},
	"catImage": "yellowstar.png",
	"totalCats": 1,
	"totalMisc": 0,
	"categories": {
		"location": 1,
		"entertainment": 1,
		"nightlife": 1
	}
};


//////////////////
// WEBPACK FOOTER
// ./src/json/vinbar.json
// module id = 998
// module chunks = 0